import React, { useState, useEffect, useRef } from 'react';
import { Modal, Row, Col } from '@nackle/origami';
import { CalendarTimeOut } from '../icons/icons.jsx';
import { LocaleString, getString } from '@nackle/intl-tools';

const SessionModal = ( props ) => {
    const [ timeoutValue, setTimeoutValue ] = useState();
    const [ promptContinue, setPromptContinue ] = useState();
    const [ promptSignOut, setPromptSignOut ] = useState();
    const [ showModal, setShowModal ] = useState( false );
    const [ authInstance ] = useState( props.auth );
    const [ timeRemaining, setTimeRemaining ] = useState();
    const [ timeoutAt, setTimeoutAt ] = useState();
    const [ loading, setLoading ] = useState( false );
    const calculateTimeRemaining = useRef();

    if ( timeoutValue && !timeoutAt ) {
        setTimeoutAt( new Date( timeoutValue ) );
    }
    if ( timeoutValue === undefined && timeoutAt ) {
        setTimeoutAt();
    }
    useEffect( () => {
        authInstance.events.sessionExpiring.on( handleSessionExpiring );
        return () => {
            authInstance.events.sessionExpiring.off( handleSessionExpiring );
        };
    }, [] );

    let interval = null;

    useEffect( () => {
        if ( timeoutAt && calculateTimeRemaining.current === undefined && timeoutValue ) {
            interval = setInterval( () => {
                calculateDifference( timeoutAt );
            }, 1000 );
            calculateTimeRemaining.current = interval;
        }
        if ( !timeoutAt && !timeoutValue && calculateTimeRemaining.current ) {
            setTimeoutAt();
            clearInterval( calculateTimeRemaining.current );
            clearInterval( interval );
            interval = null;
        }

    }, [ timeoutAt ] );

    return (
        <Modal
            open={ showModal }
            closable={ false }
            okButtonProps={ { className: 'primary-background', shape: 'round', loading: loading } }
            cancelButtonProps={ { className: 'primary-color primary-border', shape: 'round' } }
            wrapClassName={ 'session-timeout' }
            okText={ getString( 'umbrella.session.signin' ) }
            cancelText={ getString( 'umbrella.session.signout' ) }
            maskClosable={ false }
            onOk={ () => { handleOk(); } }
            onCancel={ handleCancel }
            width={ 530 }
            centered={ true }>
            <Row justify='center'>
                <Col>
                    <CalendarTimeOut />
                </Col>
            </Row>
            <Row justify='center'>
                <Col span={ 16 }>
                    <div className="expire-text">
                        <LocaleString code="umbrella.session.timeout" />
                    </div>
                    <div className="countdown">
                        { timeRemaining }
                    </div>
                </Col>
            </Row>
        </Modal>
    );

    function handleOk() {
        setLoading( true );
        promptContinue();
        setTimeoutValue();
        setTimeoutAt();
        clearInterval( calculateTimeRemaining.current );
        calculateTimeRemaining.current = undefined;
        clearInterval( interval );
        interval = null;
        setTimeout( () => {
            setTimeoutValue();
            setTimeoutAt();
            clearInterval( calculateTimeRemaining.current );
            calculateTimeRemaining.current = undefined;
            clearInterval( interval );
            interval = null;
            setShowModal( false );
            setLoading( false );
            promptContinue();
            setTimeRemaining();
        }, 1000 );

    }

    function handleCancel() {
        setShowModal( false );
        setTimeoutValue();
        promptSignOut();
    }

    function handleSessionExpiring( e ) {
        setTimeoutValue( e.timeoutAt );
        setShowModal( true );
        setPromptContinue( () => e.continue );
        setPromptSignOut( () => e.signOut );
    }

    function calculateDifference( timeoutAt ) {
        const promptDifference = ( timeoutAt - new Date() );
        let seconds = Math.floor( promptDifference / 1000 );
        let minutes = 0;
        if ( timeoutAt < new Date() ) {
            authInstance.signOut( { sessionExpired: true } );
            return;
        }
        if ( seconds ) {
            if ( seconds > 59 ) {
                minutes = Math.floor( seconds / 60 );
                seconds = Math.abs( minutes * 60 - seconds );
                if ( seconds < 10 ) {
                    seconds = `0${ seconds }`;
                }
            } else {
                if ( seconds < 1 ) {
                    authInstance.signOut( { sessionExpired: true } );
                    return;
                }
                if ( seconds < 10 ) {
                    seconds = `0${ seconds }`;
                }
            }
            const timeRemaining = `${ minutes }:${ seconds }`;

            setTimeRemaining( timeRemaining );
        }
    }
};

export default SessionModal;
